// extracted by mini-css-extract-plugin
export default {"verifiedOld":"verified-badge_verifiedOld__XAK50","verifiedBlue":"verified-badge_verifiedBlue__X8TgY","verifiedGovernment":"verified-badge_verifiedGovernment__TVDZo"};